/**
 * useCamera — CameraActionButton component
 */

import React from 'react';

export interface CameraActionButtonProps {
  onClick: () => void;
  active?: boolean;
  activeClass?: string;
  disabled?: boolean;
  label: string;
  children: React.ReactNode;
}

export function CameraActionButton({
  onClick,
  active,
  activeClass,
  disabled,
  label,
  children,
}: CameraActionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`relative w-12 h-12 rounded-full flex items-center justify-center transition-all active:scale-90 disabled:cursor-not-allowed disabled:opacity-40 disabled:active:scale-100 ${active ? activeClass || 'bg-yellow-400 text-gray-900 shadow-[0_0_12px_rgba(234,179,8,0.5)]' : 'bg-white/10 text-white hover:bg-white/20 disabled:hover:bg-white/10'
        }`}
      aria-label={label}
    >
      {children}
    </button>
  );
}
